import { render } from "./BuyMarine.vue?vue&type=template&id=30c787c1&scoped=true"
import script from "./BuyMarine.vue?vue&type=script&lang=js"
export * from "./BuyMarine.vue?vue&type=script&lang=js"

import "./BuyMarine.vue?vue&type=style&index=0&id=30c787c1&scoped=true&lang=css"

import exportComponent from "C:\\Users\\oaromasodun\\Desktop\\MarinePortal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30c787c1"]])

export default __exports__